const $ = window.jQuery;
const $window = window.$window || $(window);

/**
 * Enables auto-downloading of files
 */
const AutoDownload = {

    selector: 'a[auto-download]',

    /**
     * Initialise functionality
     */
    init()
    {

        let vm = this,
            $els = $(vm.selector);

        if (!$els.length) {
            return;
        }

        $els.get(0).click(); // trigger download

    },

    /**
     * Allow revalidating auto-download elements
     */
    revalidate()
    {
        this.$els = $(this.selector);
    },

};

export default AutoDownload;